import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimaryThree = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimaryThree.palette['--sui-palette-background-primary'] = '31 116 74';

export { WinterHoliday2026PrimaryThree };